function Page2() {
  return (
    <div><strong>Bleep 2</strong></div>
  );
}

export default Page2;
